import * as Yup from "yup";
import { AppFilter } from "../../app/AppModels";
import { PurchaseUnit } from "../Integration/DmsSetup";
export enum CatalogProductStatus {
  Active,
  Draft,
}
export interface Image {
  id?: string;
  url: string;
  absoluteUrl?: string;
  sequence: number;
  productId?: string;
  product?: any;
  title?: string;
  description?: string;
}
export interface Picture {
  id?: string;
  title: string;
  description?: string;
  syncWithShopify: boolean;
}
export interface Colors {
  id?: string;
  title: string;
  shortTitle: string;
  productId?: string;
}

export interface Dimension {
  id?: string;
  productId?: string;
  weight?: number;
  weightUnit?: number;
  width?: number;
  widthUnit?: number;
  height?: number;
  heightUnit?: number;
  depth?: number;
  depthUnit?: number;
  length?: number;
  lengthUnit?: number;
  purchaseUnit?: PurchaseUnit;
  product?: any;
}

export interface Category {
  id?: string;
  title: string;
  shortTitle: string;
  shopifyTitle?: string;
  isSubCategory: boolean;
  parentCategoryId?: any;
  parentCategory?: Category;
  taxonomyCategoryId?: string;
  taxonomyCategoryTitle?: string;
}
export interface CatalogCategoryResponse {
  category: Category;
  productCount: number;
}
export interface TaxanomyCategory {
  id: string;
  name: string;
  fullName: string;
}
export interface SubCategory {
  id?: string;
  title: string;
  shortTitle: string;
  isSubCategory: boolean;
  parentCategoryId?: any;
}

export interface ProductManufacturer {
  id?: string;
  title: string;
  shortTitle: string;
  commonMfgId?: number;
}
export interface CatalogManufacturerResponse {
  manufacturer: ProductManufacturer;
  productCount: number;
}
export interface Product {
  id?: string;
  productId?: string;
  title: string;
  shortTitle?: string;
  modelNumber: string;
  modelName: string;
  year?: string;
  sku?: string;
  powerType?: string;
  upc?: string;
  manufacturerId: string;
  productCategoryId: string;
  productSubCategoryId: string;
  description?: string;
  colors?: Colors[];
  tags?: any[];
  isEnabled: boolean;
  isNewProduct: boolean;
  isDeleted: boolean;
  images?: Image[];
  dimension?: Dimension;
  category?: Category;
  subCategory?: SubCategory;
  productManufacturer?: ProductManufacturer;
  status: CatalogProductStatus;
}
export interface ProductSection {
  id: string;
  sectionNumber: string;
  title: string;
  shortTitle: string;
  imgUrl?: string;
  isActive?: boolean;
}

export const ProductInitialValues: Product = {
  title: "",
  modelNumber: "",
  modelName: "",
  year: "",
  manufacturerId: "",
  productCategoryId: "",
  description: "",
  isEnabled: true,
  isDeleted: false,
  sku: "",
  powerType: "",
  isNewProduct: true,
  productSubCategoryId: "",
  dimension: {
    depth: 0,
    height: 0,
    weight: 0,
    width: 0,
    length: 0,
    lengthUnit: 1,
    depthUnit: 1,
    heightUnit: 1,
    weightUnit: 0,
    widthUnit: 1,
  },
  tags: [],
  colors: [],
  status: CatalogProductStatus.Active,
};
export const CategoryInitialValues: Category = {
  title: "",
  shortTitle: "",
  isSubCategory: false,
};

export const ProductSectionInitialValues: ProductSection = {
  title: "",
  shortTitle: "",
  id: "",
  sectionNumber: "",
  imgUrl: "",
  isActive: false,
};

export const PictureInitialValues: Picture = {
  title: "",
  syncWithShopify: false,
};
export const ProductValidationSchema = Yup.object().shape({
  title: Yup.string().required("Title is a required field"),
  modelNumber: Yup.string().required("Model Number is a required field"),
  // modelName: Yup.string().required("Model Name is a required field"),
  manufacturerId: Yup.string().required("Manufacturer is a required field"),
  productCategoryId: Yup.string().required(
    "Product Category is a required field"
  ),
});
export const CategoryValidationSchema = Yup.object().shape({
  title: Yup.string().required("Title is a required field"),
  shortTitle: Yup.string().required("Short Title is a required field"),
  isSubCategory: Yup.boolean(),
  parentCategoryId: Yup.string().when("isSubCategory", {
    is: true,
    then: Yup.string().required("Select Parent Category"),
    otherwise: Yup.string().nullable(true).notRequired(),
  }),
  taxonomyCategoryId: Yup.string().required("Select Taxonomy Category"),
});

export const ProductSectionValidationSchema = Yup.object().shape({
  title: Yup.string().required("Title is required field"),
  shortTitle: Yup.string().required("Short Title is required field"),
  sectionNumber: Yup.number()
    .typeError("Please enter only Integer value")
    .required("Section Number is required"),
});

export const ManufacturerValidationSchema = Yup.object().shape({
  title: Yup.string().required(),
});
export const PictureValidationSchema = Yup.object().shape({
  title: Yup.string().required(),
});
export const MassUnit = [
  {
    title: "Gram",
    value: 0,
  },
  {
    title: "Kilogram",
    value: 1,
  },
  {
    title: "Pound",
    value: 2,
  },
];

export const LenghtUnit = [
  {
    title: "Foot",
    value: 0,
  },
  {
    title: "Inch",
    value: 1,
  },
  {
    title: "Meter",
    value: 2,
  },
  {
    title: "Yard",
    value: 3,
  },
  {
    title: "Mile",
    value: 4,
  },
];

export const colors = [
  "black",
  "Camouflage",
  "Orange",
  "Army",
  "Beige",
  "Black",
  "Blue",
  "Camel",
  " Dark Gray",
  " Darl Blue",
  "Fray",
  "Gray",
  "Green",
  "Jet Black",
  "Light Gray",
  "Light Green",
  "Maroon",
  "Multi",
  "Multiple",
  "Musturd",
  "Navy Blue",
  "Oarnge",
  "Off White",
  "Orange",
  "Pink",
  "Red",
  "Sea Green",
  "Silver",
  "Silver Gray",
  "Steel Blue",
  "White",
  "Wood",
  "Yellow",
  "Zink",
  "ZinkBlue",
];
export interface ProductState {
  filters: AppFilter;
}
